var render, staticRenderFns
import script from "./ButtonGroup.vue?vue&type=script&lang=js"
export * from "./ButtonGroup.vue?vue&type=script&lang=js"
import style0 from "../../theme/button-group.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./ButtonGroup.vue?vue&type=style&index=1&id=566162ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566162ee",
  null
  
)

export default component.exports